/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {LogLevel, PublicClientApplication} from '@azure/msal-browser';
import {config} from './config';

/**
 * Configuration object to be passed to MSAL instance on creation:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */

export const msalConfig = {
    auth: {
        clientId: config.AZUREAD_CLIENT_ID + '',
        authority: config.AZUREAD_LOGIN_URL + config.AZUREAD_AUTHORITY_ID,
        redirectUri: config.AZUREAD_REDIRECT_URL,
        postLogoutRedirectUri: '/',
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: 'localStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level: any, message: any, containsPii: any) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

export const publicClientApplication = new PublicClientApplication(msalConfig);

/**
 * Intentionally empty: the app only needs ID tokens (sent as Bearer to our own APIs).
 * Do NOT use the clientId-as-scope trick to work around MSAL's empty-scopes cache miss
 * (https://github.com/AzureAD/microsoft-authentication-library-for-js/issues/6887): in tenants with MFA forced
 * that request trips a Conditional Access MFA policy that silent flows cannot satisfy,
 * so every acquireTokenSilent fails with interaction_required (AADSTS50076) and users are
 * bounced into a login/redirect loop right after MFA. The excess /token traffic is mitigated
 * by caching the ID token in src/data/api/api.ts instead.
 */
export const authScopes: string[] = [];

export const loginRequest = {
    scopes: authScopes,
};
